// @ts-nocheck
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import ErrorBoundary from '@/components/ErrorBoundary';
import ErrorFallback from '@/components/ErrorFallback';
import { getRouter } from '@/routes/Router';

import handleWhiteScreenOfDeath from './handleWhiteScreenOfDeath';

const renderApplication = ({
    id,
    reduxStore,
    translations,
    injectedDocument,
    injectedHandleWhiteScreenOfDeath = handleWhiteScreenOfDeath,
}) => {
    try {
        const container = injectedDocument.getElementById(id);
        const root = createRoot(container);

        root.render(
            <Provider store={reduxStore}>
                <ErrorBoundary fallback={<ErrorFallback />}>
                    <RouterProvider router={getRouter(translations)} />
                </ErrorBoundary>
            </Provider>
        );
    } catch (error) {
        injectedHandleWhiteScreenOfDeath(error, id);
    }
};

export default renderApplication;
